import { Form, FormInputProps } from '@servicetitan/design-system';

interface NumberInputProps extends FormInputProps {
  onChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    data: { value: string },
  ) => void;
}

const filterNumbers = (input?: string): string | undefined => {
  const regex = /[^\d.-]/g;
  return input?.replace(regex, '');
};

const isDecimalValue = (value: string) => /^-?\d*\.?\d*$/.test(value);

const NumberInput = ({ onChange, ...restProps }: NumberInputProps) => {
  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = filterNumbers(e.target.value);

    if (!value) {
      onChange(e, { value: '' });
    } else {
      const isValidNumber = isDecimalValue(value);
      const parsedValue = parseFloat(value);
      if (isValidNumber || isNaN(parsedValue)) {
        onChange(e, { value });
      } else {
        onChange(e, { value: parsedValue.toString() });
      }
    }
  };

  return <Form.Input onChange={onChangeHandler} {...restProps} />;
};

export default NumberInput;
